import React, { useEffect } from "react";
import useState from "react-usestateref";
// import "./table.css";
import { Table, theme, Pagination } from "antd";
import ReactDragListView from "react-drag-listview";
import { ConfigProvider } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  SetWarrantyStack,
  SetWarrantyColumnSort,
  SetWarrantyColumnSortOrder,
  SetWarrantyPageNumber,
  SetWarrantyRowsPerPage,
  SetWarrantyColumns,
} from "../../../Actions/Warranty";
import { SetSessionExpired } from "../../../Actions";
// import { SetTableOrder } from "../../../Actions";
import { postSelectAllBatteries } from "../../../Api/WarrantyApi";
import { useNavigate, useLocation } from "react-router-dom";
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";
import { ThemeProperties } from "../../../Theme/ThemeProperties";
import NoData from "../../../Helper/Loaders/NoData";
import CODE from "../../../Static/Constants/StatusCodes";
import { handleScroll } from "./TableFunctions";
import {
  decryptTheParams,
  encryptTheParams,
} from "../../../Helper/QueryParams/EncryptDecrypt";
import Events from "../../../Analytics/Events";
import { convertUTCtoZone } from "../../../Helper/DatePicker/DateConverter";
import { formatDateNumeric } from "../../../Helper/DatePicker/DateFormatters";

export default function BasicTableWarranty(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // ############  Search  ###########
  //   const preColumns = props.columns.map((column) => {
  //     return { ...column };
  //   });
  let index = props.columns.findIndex(
    (item) => item.name === props.warrantyCode
  );
  let finalIndex = index === -1 ? 0 : index;
  // console.log(props.columns[finalIndex]["columns"],finalIndex)
  const [columns, setColumns] = useState(props.columns[finalIndex]["columns"]);

  const queryParams = decryptTheParams();

  const [list, setList] = useState({
    batteries: [],
    responseStatus: { code: CODE.LOADING, msg: "" },
  }); ////vvvvvvImp
  const [loader, setLoader] = useState(false);
  const universal = useSelector((state) => state.WarrantyStack.arr);
  // const existingBatteries = useSelector(
  //   (state) => state.DashboardExistingBatteries.arr
  // );
  const pageNumber = useSelector((state) => state.WarrantyPageNumber.value);
  const rowsPerPage = useSelector((state) => state.WarrantyRowsPerPage.value);

  const dragProps = {
    onDragEnd(fromIndex, toIndex) {
      let dragIndex = props.rowSelection
        ? fromIndex > 1 && toIndex > 1
        : fromIndex > 0 && toIndex > 0;

      let index = props.columns.findIndex(
        (item) => item.name === props.warrantyCode
      );
      let finalIndex = index === -1 ? 0 : index;

      if (dragIndex) {
        const newColumns = [...columns];
        const item = props.rowSelection
          ? newColumns.splice(fromIndex - 1, 1)[0]
          : newColumns.splice(fromIndex, 1)[0];
        props.rowSelection
          ? newColumns.splice(toIndex - 1, 0, item)
          : newColumns.splice(toIndex, 0, item);

        setColumns(newColumns);

        const finalColumns = [...props.columns];
        finalColumns[finalIndex]["columns"] = newColumns;

        dispatch(SetWarrantyColumns(finalColumns));
      }
    },
    nodeSelector: "th",
    enableScroll: true,
    scrollSpeed: 20,
  };

  const rowSelection = {
    selectedRowKeys: universal,

    onSelectAll: function (selected, selectedRows, changeRows) {
      clickedSelectAllCheckbox(selected);
    },

    onSelect: function (selected, selectedRows, changeRows) {
      if (selectedRows) {
        let uniqueChars = [...universal, selected.warrantyID];
        dispatch(SetWarrantyStack(uniqueChars));
      } else {
        let uniqueChars = universal.filter((key) => key != selected.warrantyID);
        dispatch(SetWarrantyStack(uniqueChars));
      }
    },
    renderCell: (a, b, c, d) =>
      d.props.disabled ? (
        <IndeterminateCheckBoxIcon
          sx={{ fontSize: "20px", color: "#d8d8d8", cursor: "no-drop" }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        />
      ) : (
        d
      ),
    getCheckboxProps: (record) => ({
      // disabled: existingBatteries.includes(record.itemID),
      // Column configuration not to be checked
    }),
  };

  function hideColumns(columns) {
    return columns.filter((item) => !item.hidden);
  }

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter.column) {
      let order = sorter.order === "ascend" ? "asc" : "desc";
      console.log(sorter.columnKey);
      dispatch(SetWarrantyColumnSort(sorter.columnKey));
      dispatch(SetWarrantyColumnSortOrder(order));
    }
  };

  const handlePageChange = (page, pageSize) => {
    dispatch(SetWarrantyPageNumber(page));
  };

  const onShowSizeChange = (current, pageSize) => {
    console.log(current, pageSize);
    dispatch(SetWarrantyPageNumber(1));

    dispatch(SetWarrantyRowsPerPage(pageSize));
  };

  function clickedSelectAllCheckbox(selectAll) {
    let newtempIds = [];
    postSelectAllBatteries(
      props.warrantyCode,
      props.iot,
      props.pack,
      props.cycle,
      props.age,
      props.soh
    ).then((res) => {
      if (res.responseStatus.code === 200) {
        newtempIds = selectAll ? res.response.warrantyItemID : [];
        let tempSelected = res.response.warrantyItemID;

        let finalArr = tempSelected.filter((n) => !newtempIds.includes(n));

        let final2 = universal.filter((n) => !finalArr.includes(n));

        let final3 = final2.concat(newtempIds);
        let final4 = final3.filter((n) => !props.existingBatteries.includes(n));

        let uniqueChars = [...new Set(final4)];
        dispatch(SetWarrantyStack(uniqueChars));
      } else {
        if (res.responseStatus.code === -2) dispatch(SetSessionExpired(true));
        dispatch(SetWarrantyStack([]));
      }
    });
  }

  useEffect(() => {
    if (props.data && props.data.batteries.length > 0) {
      // props.data.responseStatus.code !== 1999/404
      let newData = props.data.batteries.map((row) => ({
        ...row,
        checked: false,
      }));

      setList({
        batteries: newData,
        responseStatus: {
          code: props.data.responseStatus.code,
          msg: props.data.responseStatus.msg,
        },
      });
    } else {
      setList({
        batteries: [],
        responseStatus: {
          code: props.data.responseStatus.code,
          msg: props.data.responseStatus.msg,
        },
      });
    }
  }, [props.data]); // eslint-disable-line react-hooks/exhaustive-deps

  // useEffect(()=>{

  //   let index = props.columns.findIndex((item)=>item.name === props.warrantyCode);
  // let finalIndex = index === -1 ? 0 : index;
  // // console.log(props.warrantyCode,props.columns,finalIndex)

  // // console.log(props.columns[finalIndex]["columns"],finalIndex)
  // // const [columns, setColumns] = useState(
  // //   props.columns[finalIndex]["columns"]
  // // );
  // // setColumns(props.columns[finalIndex]["columns"])
  // },[props.warrantyCode])

  return (
    <>
      {console.log("columns", columns)}
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#6D72F6",
          }
        }}
      >
        <ReactDragListView.DragColumn {...dragProps}>
          <Table
            onRow={(record, rowIndex) => {
              return {
                onClick: (event) => {
                  if (
                    event.target.classList[1] ===
                      "ant-table-selection-column" ||
                    event.target.classList[0] === "ant-checkbox-inner" ||
                    event.target.classList[2] === "ant-checkbox-checked" ||
                    event.target.classList[0] === "ant-checkbox-wrapper" ||
                    event.target.classList[0] === "ant-checkbox"
                  ) {
                  } else {
                    if (universal.length > 0) {
                      event.preventDefault();
                      props.handleOpenExportCSVConfirm();
                    } else {
                      let temp;
                      temp = {
                        ...queryParams,
                        batteryID: record.batteryID,
                        // startDateSB: formatDateNumeric(
                        //   new Date(convertUTCtoZone(record.alertTime))
                        // ),
                        // endDateSB: formatDateNumeric(new Date()),
                        // alertFirstSeenOn: convertUTCtoZone(record.alertTime),
                        batterySearchedGlobal: "false",
                        tabValue: 3,
                        tabName: "Warranty Claims",
                        prevLink: location.pathname + location.search,
                      };
                      encryptTheParams(temp, navigate, true);
                    }
                  }
                  // navigate(`/specificBattery?batteryID=${record.batteryID}`, {
                  //   state: { detail: record.batteryID, tabValue: 0, tabName:"Alerts" },
                  // });
                }, // click row
              };
            }}
            className={
              props.rowSelection
                ? "LandingPageTable Selection"
                : "LandingPageTable NoSelection"
            }
            locale={{
              emptyText: (
                <div style={{ minHeight: "500px", height: "500px" }}>
                  {list.responseStatus.code === 1999 ||
                  list.responseStatus.code === 404 ? (
                    <div style={{ height: "100%" }}>
                      <NoData text={"No batteries found"} />
                    </div>
                  ) : (
                    <p style={{ height: "100%", color: "white" }}></p>
                  )}
                </div>
              ),
            }}
            columns={hideColumns(columns)}
            rowSelection={props.rowSelection && rowSelection}
            rowKey={(record) => record.warrantyID}
            rowClassName="rowClass"
            dataSource={
              list.responseStatus.code === CODE.LOADING
                ? []
                : list.responseStatus.code === 1999 ||
                  list.responseStatus.code === 404
                ? []
                : list.batteries
            }
            pagination={false}
            loading={
              list.responseStatus.code === CODE.LOADING
                ? true
                : list.responseStatus.code === CODE.NODATA
                ? false
                : false
            }
            onChange={handleTableChange}
            style={{ height: "575px" }}
            scroll={handleScroll([...columns])}
            bordered
            size="middle"
          />
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "right",
            }}
          >
            <Pagination
              showSizeChanger
              onShowSizeChange={onShowSizeChange}
              pageSize={rowsPerPage}
              pageSizeOptions={[10, 20, 30, 100]}
              current={pageNumber}
              onChange={handlePageChange}
              total={props.total}
              showTotal={(total, range) => `${range[0]}-${range[1]}/${total}`}
            />
          </div>
        </ReactDragListView.DragColumn>
      </ConfigProvider>
    </>
  );
}
